import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "ml-[10px]",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "18",
  height: "18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "white",
  transform: "translate(1.5 0)",
  d: "M7.1538463 0C9.0559654 0 10.615385 1.5594195 10.615385 3.4615386L10.615385 4.6153846L13.615385 4.6153846C13.997725 4.6154227 14.307693 4.9253783 14.307693 5.3076925L14.307693 14.538462C14.307693 16.44058 12.748273 18 10.846154 18L3.4615386 18C1.5594195 18 0 16.44058 0 14.538462L0 5.3076925C0 4.9253783 0.30996716 4.6154227 0.69233078 4.6153846L3.6923077 4.6153846L3.6923077 3.4615386C3.6923077 1.5594195 5.2517271 0 7.1538463 0ZM3.6923077 6L1.3846154 6L1.3846154 14.538462C1.3846154 15.70465 2.2953496 16.615385 3.4615386 16.615385L10.846154 16.615385C12.012342 16.615385 12.923077 15.70465 12.923077 14.538462L12.923077 6L10.615385 6L10.615385 8.9801722C10.615385 9.3625231 10.305428 9.6724796 9.9230766 9.6724796C9.5407257 9.6724796 9.2307692 9.3625231 9.2307692 8.9801722L9.2307692 6L5.0769229 6L5.0769229 8.9801722C5.0769229 9.3625231 4.7669663 9.6724796 4.3846154 9.6724796C4.0022645 9.6724796 3.6923077 9.3625231 3.6923077 8.9801722L3.6923077 6ZM7.1538463 1.3846154C5.9876575 1.3846154 5.0769229 2.2953496 5.0769229 3.4615386L5.0769229 4.6153846L9.2307692 4.6153846L9.2307692 3.4615386C9.2307692 2.2953496 8.320035 1.3846154 7.1538463 1.3846154Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}